import React, { useState, useEffect } from "react";
import { fetchJson } from "../../lib/Fetching";
import Link from "../Link";
import { getDueDate, formattedDueDate, formatDate, toDate } from "../../lib/trays/TrayUtils";

export default function LocationReport({ trayIds }) {
  const [trays, setTrays] = useState(null);
  useEffect(
    () => {
      fetchJson("/trays/location_reports.json", { tray_ids: trayIds }).then((json) =>
        setTrays(json)
      );
    },
    [trayIds]
  );

  if (!trays) return <div>Loading...</div>;

  // const maximumAncestorsChain = Math.max(trays.map((t) => t.ancestors.length));

  return (
    <div className="basic-panel with-padding">
      <h3 style={{ margin: 0, padding: 0 }}>Tray Locations</h3>
      <table className="table table-hover table-bordered" style={{ marginBottom: 0 }}>
        <thead>
          <tr>
            <th>Item Count</th>
            <th>Due Date</th>
            <th>Tray Name</th>
            <th>Parent Location</th>
          </tr>
        </thead>
        <tbody>
          {trays.map((t) => (
            <tr>
              <td>{t.item_count}</td>
              <td>{formattedDueDate(t)}</td>
              {t.ancestors.map((ancestor) => (
                <td>
                  <a href={"/tracking/items/" + ancestor.item_id} target="_blank">
                    {ancestor.name} [{ancestor.item_type}]
                  </a>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
